import { RegionalGrantRule } from "../api/onBoarding";

const INDIA_RULE: RegionalGrantRule = {
  country: "India",
  minCliffMonths: 12,
  minStrikePrice: 0,
};

const normalizeCountry = (country: string) =>
  country.trim().replace(/\s+/g, " ").toLocaleLowerCase();

export function resolveRegionalGrantRule(
  rules: RegionalGrantRule[] | undefined,
  country: string | undefined
): RegionalGrantRule {
  const indiaRule =
    rules?.find(
      (rule) => normalizeCountry(rule.country) === normalizeCountry("India")
    ) || INDIA_RULE;

  if (!country) return indiaRule;
  return (
    rules?.find(
      (rule) => normalizeCountry(rule.country) === normalizeCountry(country)
    ) || indiaRule
  );
}
